import {Pipe, PipeTransform} from '@angular/core';
import {ProductMiseEnPlaceDto} from '../../../Models/YuChef/Mise-en-place/mise-en-place-stock.interface';

@Pipe({
  name: 'miseEnPlace',
  standalone: false
})
export class MiseEnPlacePipe implements PipeTransform {

  transform(items: ProductMiseEnPlaceDto[], filters: {
    family?: number[],
    category?: number[],
    criticalStock?: boolean,
  }): ProductMiseEnPlaceDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filters?.family?.length) {
      items = items.filter((item) => filters.family?.includes(item.id_familia));
    }

    if (filters?.category?.length) {
      items = items.filter((item) => filters.category?.includes(item.id_partida));
    }

    if (filters.criticalStock) {
      items = items.filter((item) => item.min.today && item.cantidad < item.min.today);
    }

    return items;

  }

}
